module.exports = __webpack_public_path__ + "img/proofofaddress.8ce482c4.png";